import {
    get,
    post,
    formDataPost,
    postWithQuery,
    Delete,
} from "../ApiDecorator";

/**
 * 组卷任务（/course/spx/examCompose）
 */
const ExamCompose = {
    /** GET 当前项目组卷任务列表 */
    getList(data) {
        return get("/course/spx/examCompose/list", data);
    },
    /** GET 按学段、学科筛可选子空间 */
    getSpaces(data) {
        return get("/course/spx/examCompose/spaces", data);
    },
    /**
     * POST 新建或修改未发布任务
     * 细目表：预置不传 specMode（默认固定表头）；自建传 specMode=1 且 specColumns 必填，specs 可为 []
     */
    save(data) {
        return post("/course/spx/examCompose/save", data);
    },
    /**
     * GET 任务详情
     * query: id 必填；owner=mine 仅 specMode=1 时回当前用户行
     */
    getDetail(data) {
        return get("/course/spx/examCompose/detail", data);
    },
    /**
     * POST 导入细目表，只解析不入库
     * form: file 必填；自建传 specMode=1，预置不传（后端自动判断）
     * 返回：fileName、specMode、rowCount、specColumns（仅 mode=1）、specs
     */
    importSpec(data) {
        return formDataPost("/course/spx/examCompose/importSpec", data);
    },
    /** POST 发布任务，query: id */
    publish(data) {
        return postWithQuery("/course/spx/examCompose/publish", {}, data);
    },
    /** DELETE 逻辑删除任务，query: id */
    delete(data) {
        return Delete("/course/spx/examCompose", data);
    },
};

export default ExamCompose;
